import ArrowLeftIconComponent from "./ArrowLeftIconComponent";

export default ArrowLeftIconComponent;
